import React from "react";
import styled from "styled-components";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTimes } from "@fortawesome/free-solid-svg-icons";

import { CostEstimationStatus, ProjectCostsEditing } from "../../../../common/types";
import { POPCostEstimationIndicator } from "./POPCostEstimationIndicator";
import { cancelRed, disabledGrey, valmetGreyTable, warningYellow } from "../../../../common/colors";

type ProjectCostEstimationStatusProps = {
  costEstimationStatus: CostEstimationStatus;
  editing: ProjectCostsEditing;
};

function ProjectCostEstimationStatus(props: ProjectCostEstimationStatusProps) {
  const { costEstimationStatus: status, editing } = props;
  return (
    <Container>
      <POPCostEstimationIndicator status={status} />
      {!editing.enabled && editing.disabledReason !== null && (
        <StatusContainer title="Editing is disabled">
          <Title>
            <div>
              <FontAwesomeIcon icon={faEdit} color={disabledGrey} />
              <OverlayIcon behind={true} icon={faTimes} color={valmetGreyTable} />
              <OverlayIcon behind={false} icon={faTimes} color={cancelRed} />
            </div>
            <b>{(editing.disabledTitle && editing.disabledTitle) || "Editing disabled"}</b>
          </Title>
          <Reason>{editing.disabledReason}</Reason>
        </StatusContainer>
      )}
    </Container>
  );
}

export default ProjectCostEstimationStatus;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
  column-gap: 10px;
`;

const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  /*align-items: center;*/
  gap: 10px;
  padding: 6px;
  background: ${warningYellow};
  border: 1px solid #fc0;
`;

const OverlayIcon = styled(({ behind, ...rest }) => <FontAwesomeIcon {...rest} />)<{ behind: boolean }>`
  position: absolute;
  margin-left: ${({ behind }) => (behind ? "-21px" : "-21px")};
  margin-top: ${({ behind }) => (behind ? "6px" : "8px")};
  font-size: ${({ behind }) => (behind ? "1.2em" : "1em")};
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const Reason = styled.div`
  white-space: pre;
`;
